/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createPaginatedListOfChargerDefinitionSummaryFromDiscriminatorValue, createProblemDetailsFromDiscriminatorValue, serializeCreateChargerDefinitionCommand, type CreateChargerDefinitionCommand, type MidMeterType, type PaginatedListOfChargerDefinitionSummary, type ProblemDetails } from '../models/index.js';
// @ts-ignore
import { ChargerDefinitionItemRequestBuilderNavigationMetadata, ChargerDefinitionItemRequestBuilderRequestsMetadata, type ChargerDefinitionItemRequestBuilder } from './item/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Guid, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /chargerdefinitions
 */
export interface ChargerdefinitionsRequestBuilder extends BaseRequestBuilder<ChargerdefinitionsRequestBuilder> {
    /**
     * Gets an item from the ApiSdk.chargerdefinitions.item collection
     * @param chargerDefinitionId Unique identifier of the item
     * @returns {ChargerDefinitionItemRequestBuilder}
     */
     byChargerDefinitionId(chargerDefinitionId: Guid) : ChargerDefinitionItemRequestBuilder;
    /**
     * GetChargerDefinitions
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<PaginatedListOfChargerDefinitionSummary>}
     * @throws {ProblemDetails} error when the service returns a 400 status code
     * @throws {ProblemDetails} error when the service returns a 404 status code
     * @throws {ProblemDetails} error when the service returns a 409 status code
     */
     get(requestConfiguration?: RequestConfiguration<ChargerdefinitionsRequestBuilderGetQueryParameters> | undefined) : Promise<PaginatedListOfChargerDefinitionSummary | undefined>;
    /**
     * CreateChargerDefinition
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<Guid>}
     * @throws {ProblemDetails} error when the service returns a 400 status code
     * @throws {ProblemDetails} error when the service returns a 404 status code
     * @throws {ProblemDetails} error when the service returns a 409 status code
     */
     post(body: CreateChargerDefinitionCommand, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<Guid | undefined>;
    /**
     * GetChargerDefinitions
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<ChargerdefinitionsRequestBuilderGetQueryParameters> | undefined) : RequestInformation;
    /**
     * CreateChargerDefinition
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: CreateChargerDefinitionCommand, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * GetChargerDefinitions
 */
export interface ChargerdefinitionsRequestBuilderGetQueryParameters {
    criteria?: string;
    midMeter?: MidMeterType;
    pageNumber?: number;
    pageSize?: number;
    sortExpression?: string;
}
/**
 * Uri template for the request builder.
 */
export const ChargerdefinitionsRequestBuilderUriTemplate = "{+baseurl}/chargerdefinitions{?Criteria*,MidMeter*,PageNumber*,PageSize*,SortExpression*}";
/**
 * Mapper for query parameters from symbol name to serialization name represented as a constant.
 */
const ChargerdefinitionsRequestBuilderGetQueryParametersMapper: Record<string, string> = {
    "criteria": "Criteria",
    "midMeter": "MidMeter",
    "pageNumber": "PageNumber",
    "pageSize": "PageSize",
    "sortExpression": "SortExpression",
};
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const ChargerdefinitionsRequestBuilderNavigationMetadata: Record<Exclude<keyof ChargerdefinitionsRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    byChargerDefinitionId: {
        requestsMetadata: ChargerDefinitionItemRequestBuilderRequestsMetadata,
        navigationMetadata: ChargerDefinitionItemRequestBuilderNavigationMetadata,
        pathParametersMappings: ["chargerDefinition%2Did"],
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const ChargerdefinitionsRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: ChargerdefinitionsRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createPaginatedListOfChargerDefinitionSummaryFromDiscriminatorValue,
        queryParametersMapper: ChargerdefinitionsRequestBuilderGetQueryParametersMapper,
    },
    post: {
        uriTemplate: ChargerdefinitionsRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendPrimitive",
        responseBodyFactory:  "string",
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeCreateChargerDefinitionCommand,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
